import { PolicyDocument } from '@interfaces/documents.interface';
import { DefaultBodyType, HttpResponse, StrictRequest } from 'msw';

import { documentsDataset } from '../documents.dataset';

interface DocumentFilters {
	policyId: string | null;
	policyNumber: string | null;
	type: string | null;
	status: string | null;
}

const ITEMS_PER_PAGE = 5;
const FIRST_PAGE = 1;
const SERVER_ERROR_POLICY_ID = '500-0';
const MOCK_TRACE_ID = 'documents-mock-trace-id';

const matchesFilters = (document: PolicyDocument, filters: DocumentFilters): boolean => {
	if (filters.policyId !== null && document.metadata.policyId !== filters.policyId) return false;
	if (filters.policyNumber !== null && String(document.metadata.policyNumber) !== filters.policyNumber) return false;
	if (filters.type !== null && document.type !== filters.type) return false;
	return filters.status === null || document.status === filters.status;
};

const readPage = (value: string | null): number => {
	const page = Number(value);
	return Number.isInteger(page) && page > 0 ? page : FIRST_PAGE;
};

export const getDocumentsResolver = ({ request }: { request: StrictRequest<DefaultBodyType> }) => {
	const url = new URL(request.url);
	const policyId = url.searchParams.get('policyId');

	if (policyId === SERVER_ERROR_POLICY_ID) {
		return new HttpResponse(null, { status: 500, statusText: 'Internal Server Error' });
	}

	const filters: DocumentFilters = {
		policyId,
		policyNumber: url.searchParams.get('policyNumber'),
		type: url.searchParams.get('type'),
		status: url.searchParams.get('status'),
	};
	const currentPage = readPage(url.searchParams.get('page'));
	const filtered = documentsDataset.filter((document) => matchesFilters(document, filters));

	if (filtered.length === 0) return new HttpResponse(null, { status: 404, statusText: 'Not Found' });

	const start = (currentPage - FIRST_PAGE) * ITEMS_PER_PAGE;
	const items = filtered.slice(start, start + ITEMS_PER_PAGE);

	return HttpResponse.json({
		data: items,
		meta: {
			totalItems: filtered.length,
			itemsPerPage: items.length,
			totalPages: Math.max(Math.ceil(filtered.length / ITEMS_PER_PAGE), FIRST_PAGE),
			currentPage,
		},
		links: null,
		message: 'Success',
		statusCode: 200,
		traceId: MOCK_TRACE_ID,
	});
};
